<script>
import {DateUtil} from '@/utils/date.js'
export default {
  mounted: function () {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let minute = date.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    this.time = hour + ':' + minute
    this.date = year + '年' + month + '月' + day + '日'
    let initWeeks = [
      '日曜日',
      '月曜日',
      '火曜日',
      '水曜日',
      '木曜日',
      '金曜日',
      '土曜日'
    ]
    this.week = initWeeks[date.getDay()]
    this.weeks = initWeeks
    setInterval(() => {
      this.getDate()
      // this.getMessageInfoList()
    }, 4000)
  },
  data () {
    return {
      // messageList是否为空Flag
      flag: false,
      // 定时函数
      timer: null,
      // 第一条数据的时间：最新时间用于判断是否要轮询
      latestTime: '',
      // 获取当前日期走db查当天message
      receiveTimeStr: '',
      currentUserName: '',
      name: 'test',
      showright: false,
      broadside: true,
      broadside2: false,
      time: '',
      date: '',
      week: '',
      weeks: '',
      tablename: 'メッセージ',
      messageList: [],
      lists: [
        {
          title: '新しい予約',
          time: '2018/05/03 10:00',
          content: '山下達彦さんが予約しました'
        },
        {
          title: '運行障害',
          time: '2018/05/04 10:00',
          content: '上地区定期便'
        },
        {
          title: '新しい予約',
          time: '2018/05/05 10:00',
          content: '山下達彦さんが予約しました'
        }
      ],
      version: ''
    }
  },
  created: function () {
    this.currentUserName = sessionStorage.getItem('currentUserName')
    this.messageList = JSON.parse(sessionStorage.getItem('messageList'))
    this.flag = sessionStorage.getItem('noMessageFlag')
    // 创建时候调用一次，以解决四秒间隔问题
    this.getMessageInfoList()
    this.timer = setInterval(() => {
      this.getMessageInfoList()
    }, 5000)

    this.version = document.getElementById('appVersion').value
  },
  methods: {
    getDate: function () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      if (minute < 10) {
        minute = '0' + minute
      }
      this.time = hour + ':' + minute
      this.date = year + '年' + month + '月' + day + '日'
      this.week = this.weeks[date.getDay()]
    },
    goMessageInfoDetail () {
      // alert(this.$route.path)
      this.$router.push({name: 'MessageInfoList'})
    },
    logout () {
      this.$axios.post('user/logout')
        .then(response => {
          this.$router.push({ name: 'login' })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getMessageInfoList () {
      // console.log('a')
      let date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      // var hour = date.getHours()
      // var minute = date.getMinutes()
      // console.log(minute)
      let receiveTimeStr
      if (month < 10) {
        if (day < 10) {
          receiveTimeStr = year + '0' + month + '0' + day
        } else {
          receiveTimeStr = year + '0' + month + day
        }
        this.receiveTimeStr = receiveTimeStr
      } else {
        if (day < 10) {
          receiveTimeStr = year + '' + month + '0' + day
          // receiveTimeStr = year + '' + month + '0' + day + hour + minute
        } else {
          receiveTimeStr = year + '' + month + day
        }
        this.receiveTimeStr = receiveTimeStr
      }
      // 查询当天最新的前10条message
      this.$axios.get('shift/queryTodayMessageList', {params: {currentDateStr: this.receiveTimeStr}})
        .then(response => {
          let messageList = response.data.todayMessageList
          this.messageList = messageList
          sessionStorage.setItem('messageList', JSON.stringify(this.messageList))
          // this.latestTime = this.messageList[0].receiveTime
          // console.log(this.latestTime)
          if (this.messageList && this.messageList.length === 0) {
            this.flag = true
            sessionStorage.setItem('noMessageFlag', this.flag)
          } else {
            sessionStorage.removeItem('noMessageFlag')
            this.flag = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 转化受信時間 将yyyyMMddHHmm转化为 yyyy/mm/dd HH:mm
    convertDate (date) {
      return DateUtil.yearMonthDayandTime(date)
    }
  },
  // 离开当前页面关闭定时器
  beforeDestroy () {
    if (this.timer) { // 如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer) // 关闭
    }
  }
}
</script>

<template>
  <div class="col-md-2 column right-container div_right">
    <div class="row clearfix">
      <div class="col-md-12 column" style="padding-top:20px;">
        <div class="row clearfix">
          <div class="col-md-12 column" style="float: right;">
            {{this.currentUserName}}さん ｜
            <button class="logoutInput" @click="logout()">ログアウト</button>
          </div>
          <div class="col-md-12 column" style="float: right;text-align:right;">
            {{version}}
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix" style="flex: 1;display:flex;flex-direction:column;justify-content:center;">
      <!-- <slot name="rightbutton"/> -->
      <div class="col-md-10 column" style="padding-right: 0px;">
        <div style="font-size:4em;text-align:right;">{{time}}</div>
        <div style="font-size:1em;text-align:right;">{{date}}</div>
        <div style="font-size:1em;text-align:right;">{{week}}</div>
      </div>
    </div>
    <div class="row clearfix" style="height: 200px;margin-bottom: 10px;">
      <div class="col-md-12 column" style="height: 100%;overflow: hidden;">
        <!-- MessageInfoList界面需要隐藏-->
        <div class="RFooter slider gbc5" id="RFooter" @click="goMessageInfoDetail()" v-show="this.$route.path!=='/MessageInfoList'">
          <!-- <div class="RFooter slider gbc5" id="RFooter" @click="goMessageInfoDetail()" v-show="false"> -->
          <strong class="F3-M-16">{{tablename}}</strong>
          <div class="linedive" style="margin-left: 2%; width:96%" />
          <div class="slider" style="height:170px;">
            <div v-if="flag" class="F3-M-16" style="margin-top:60px">メッセージなし</div>
            <div v-else v-for="(list,key) in messageList" :key="key" class="RFtable ">
              <div class="RFtitle">
                <div class="listTitle">{{list.title}}</div>
                <div class="listTime" style="height:23px;line-height:23px">{{convertDate(list.receiveTime)}}</div>
              </div>
              <div class="RFDetail F3-M-16 flexDiv">
                <div style="width:200px" class="member-name" :title="list.message">{{list.message}}</div>
                <div v-if="list.type==='06'">
                  <img class="excalmatory-mark" src="@/assets/delay_mark_mid.png">
                </div>
                <div v-else-if="list.type==='10'">
                  <img class="excalmatory-mark" src="@/assets/attention_mark_mid.png">
                </div>
              </div>
              <div class="linedive" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.right-container {
  flex: 0 0 270px;
}
.div_right {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 0px;
  background: #686868;
  font-size: 17px;
  color: #fff;
  width: 100%;
}

.RFooter {
  text-align: center;
  background-color: rgb(238, 238, 238);
  padding: 0px;
  width: 100%;
  height: 100%;
  cursor:pointer;
}
.RFtable {
  display: inline-block;
  width: 96%;
  font-size: 10px;
  color: white;
  margin-left: 2%;
}
.RFtitle {
  background: #48a3be;
  margin-left: 2px;
  padding-left: 2px;
  margin-top: 5px;
  font-size: 16px;
  height: 22px;
}
.RFDetail {
  height: auto;
  min-height: 50px;
  line-height: 50px;
  text-align: left;
  color: #000000;
  margin-top: 8px;
  margin-left: 5px;
  font-size: 20px;
  /* 文字加粗 400为正常值 */
  font-weight: 580;
}
.linedive {
  border: 0.5px solid black;
}
.tiptitle{
    display: inline;
}
.titleul {
  list-style-type: none;
  list-style: none;
  float: left;
}
.choicebtn{
    background: #ffffff;
}
.listTitle{
  text-align:left;
  width:auto;
  float:left;
  padding-left:5px;
}
.listTime{
  text-align:right;
  width:auto;
  font-size:10px;
  padding-right:5px;
}

.flexDiv {
  display: flex;
  justify-content: flex-start;
}

.member-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 滑动条样式
    整体样式
*/
.slider{
  overflow:auto;
}
.slider::-webkit-scrollbar{
  width:6px;
  height: 0px;
}
/* 滚动条中小方块样式 */
.slider::-webkit-scrollbar-thumb{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #535353;
  box-shadow: none;
}
/* 滑动轨道样式 */
.slider::-webkit-scrollbar-track{
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 10px;
  background: #EDEDED;
  box-shadow: none;
}

.logoutInput {
  line-height: 30px;
  width: 100px;
  border: none;
  background: none;
  outline: none
}
</style>



// WEBPACK FOOTER //
// src/components/right-bar.vue